export default {
    // ЭКСТРАС
    sbiv_1_a: {
        grade: 1, type: 'snextra', subtype: 'extra', src: `/../images/ver2/snowman/extras/sbiv.png`,
        title: 'Сбив Обычный',
        discription: 'Ваша способность сбивать противника',
    },

    // WEAR
    snw_wear_1_a: {
        grade: 1, type: 'snwear', subtype: 'shirt', src: `/../images/ver2/scores/snowman/snw_wear_1_a.png`,
        title: 'Легкая накидка',
        discription: 'Немного защищает от мороза',  
    },
    snw_wear_pants_1_a: {
        grade: 1, type: 'snwear', subtype: 'pants', src: `/../images/ver2/scores/snowman/snw_wear_pants_1_a.png`,
        title: 'Штаны',
        discription: 'Штаны из берёзовой коры',  
    }
    // sbiv_1_a: {
    //     grade: 1, type: 'island', subtype: 'snowman', src: `/../images/ver2/snowman/extras/sbiv.png`,
    //     title: 'Сбив Обычный',
    //     discription: 'Ваша способность сбивать противника',
    // },
}